<div class="card-download {{class}}">
    <div class="card-download-icon">
        <fa-icon icon="download"></fa-icon>
    </div>
    <div class="card-download-content">
        <b>Download</b>
        <p *ngFor="let item of downloads;"><a target="_blank" href="{{ item[1] }}">{{ item[0] }}</a></p>
    </div>
</div>